import React from "react";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend dayjs plugins
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

// Common function to parse date and format based on period
export const formatDateForPeriod = (date, period) => {
  let parsedDate;

  if (period === "monthly") {
    parsedDate = dayjs(date, "YYYY-MM");
    return parsedDate.isValid() ? parsedDate.format("MMM") : "Invalid Date";
  } else if (period === "weekly") {
    parsedDate = dayjs(date, ["M/D/YYYY", "YYYY-MM-DD"]);
    return parsedDate.isValid()
      ? parsedDate.startOf("week").format("MMM DD, YYYY")
      : "Invalid Date";
  } else {
    parsedDate = dayjs(date, ["M/D/YYYY", "YYYY-MM-DD"]);
    return parsedDate.isValid()
      ? parsedDate.format("MMM DD")
      : "Invalid Date";
  }
};

export const getFormattedData = (data, period) => {
  const groupedData = {};

  // Iterate through the data to group based on period
  data?.forEach((item) => {
    if (!item?.date) return;

    const date = item?.date && dayjs(item?.date, ["M/D/YYYY", "YYYY-MM-DD"]);
    let periodKey;
    if (period === "weekly") {
      periodKey = date.startOf("week").format("YYYY-MM-DD"); // Group by start of the week
    } else if (period === "monthly") {
      periodKey = date.format("YYYY-MM"); // Group by month
    } else {
      periodKey = date?.format("YYYY-MM-DD"); // Default: daily
    }

    const seriesName = item?.name;

    if (!groupedData[seriesName]) {
      groupedData[seriesName] = {};
    }

    // Initialize period key if not already present
    if (!groupedData[seriesName][periodKey]) {
      groupedData[seriesName][periodKey] = 0;
    }

    // Sum the values for the given period key
    groupedData[seriesName][periodKey] += item?.value;
  });

  // Prepare formatted data for charting
  const formattedSeries = Object.keys(groupedData).map((seriesName) => ({
    name: seriesName, // Series name
    data: Object.values(groupedData[seriesName]), // Array of aggregated values
  }));

  // Get all the categories (unique dates for x-axis)
  const categories = Object.keys(groupedData[Object.keys(groupedData)[0]] || {});

  return {
    categories,
    seriesData: formattedSeries,
  };
};
